import fecha from 'fecha'
export const inputTypeTimer = (f, timeOut, timer) => {
    return () => {
        if (timeOut !== null) {
            clearTimeout(timeOut)
        }
        timeOut = setTimeout(() => {
            timeOut = null
            const result = f.apply(this, arguments)
            return result
        }, timer)
    }
}

export const orderStatus = (value) => {
    switch(true) {
        case value === 'inventory_reserved' || value === 'completed':
            return 'In progress'
        case value === 'packed':
            return 'Completed'
        case value === 'canceled':
            return 'Canceled'
        default:
            return value.split('_').join(' ')
    }
}

export const getWorkingDays = (startDate, period=5 ) => {
    let dates = []
    let i = 1

    let currentDate = startDate
    currentDate.setDate(currentDate.getDate()+1)
    while (i <= period) {
        let weekDay = currentDate.getDay()
        if( weekDay != 0 && weekDay != 6 ) {
            let item = fecha.format(currentDate, 'YYYY-MM-DD')
            i++
            dates.push({
                label: item + ' 08:00-17:00',
                code: item
            })
        }
        currentDate.setDate(currentDate.getDate()+1)
    }

    return dates
}



// WEBPACK FOOTER //
// ./src/utils/index.js